import styled from '@emotion/styled';

export type NotificationVariant = 'default' | 'header';

type BadgeProps = {
  $badgeColor?: string;
  $variant?: NotificationVariant;
};

type VariantProps = {
  $variant?: NotificationVariant;
};

export const Container = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BellButton = styled.button<VariantProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${({ $variant }) => ($variant === 'header' ? '#fff' : '#3d3d3d')};

  svg {
    display: block;
    flex-shrink: 0;
    width: ${({ $variant }) => ($variant === 'header' ? '18px' : '24px')};
    height: ${({ $variant }) => ($variant === 'header' ? '21px' : 'auto')};
  }
`;

export const NotificationsContainer = styled.div<BadgeProps>`
  position: absolute;
  top: ${({ $variant }) => ($variant === 'header' ? '-5px' : '-6px')};
  right: ${({ $variant }) => ($variant === 'header' ? '-10px' : '-8px')};
  min-width: ${({ $variant }) => ($variant === 'header' ? '22px' : '18px')};
  height: ${({ $variant }) => ($variant === 'header' ? '14px' : '18px')};
  padding: ${({ $variant }) => ($variant === 'header' ? '0 4px' : '0 4px')};
  background: ${({ $badgeColor }) => $badgeColor || '#fc0d1b'};
  border-radius: ${({ $variant }) => ($variant === 'header' ? '4px' : '999px')};
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const NotificationsHeader = styled.div`
  background-color: #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 62px;
  gap: 8px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export const NotificationText = styled.span<VariantProps>`
  font-family: 'Mangueira', sans-serif;
  font-size: ${({ $variant }) => ($variant === 'header' ? '10px' : '12px')};
  line-height: 1;
  color: #fff;
  text-align: center;
  font-weight: 700;
  white-space: nowrap;
`;

export const NotificationsIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid #007bff;
  position: absolute;
  right: 12px;
  top: -8px;

  @media (max-width: 600px) {
    display: none;
  }
`;

export const NotificationsBox = styled.div<VariantProps>`
  z-index: 5;
  position: absolute;
  top: ${({ $variant }) => ($variant === 'header' ? '32px' : '40px')};
  right: ${({ $variant }) => ($variant === 'header' ? '-4px' : '-6px')};

  @media (max-width: 600px) {
    right: ${({ $variant }) => ($variant === 'header' ? '-48px' : '-60px')};
  }
`;

export const NotificationsBoxContainer = styled.div`
  background: #fff;
  border-radius: 5px;
  box-shadow: rgb(216, 216, 216) 0px 0px 8px;
  display: flex;
  max-height: 432px;
  overflow: auto;

  @media (max-width: 600px) {
    max-width: 362px;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  font-family: 'Mangueira Bold', sans-serif;
  display: inline-flex;
`;

export const QuantityContainer = styled.div`
  background: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const QuantityText = styled.span`
  color: #007bff;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Mangueira Bold', sans-serif;
  display: inline-flex;
`;

export const NotificationsItems = styled.div`
  margin-top: 75px;
  padding: 0 18px;
  padding-bottom: 16px;
`;
